// extracted by mini-css-extract-plugin
export default {"container":"Input_container__F0lZL","input":"Input_input__0xc7a","icon":"Input_icon__MFTLM"};